import { AssessmentContent } from '@protos/learning_management/lms.assessment.common.apis_pb';
import {
  CreateTeacherAssessmentSessionResponse,
  TeacherPreviousAssessmentSession,
} from '@protos/learning_management/lms.clickerAssessment.teacher.apis_pb';
import {
  BaseStationDetails,
  StudentClickerData,
  UpsertConnectedClassSessionResponseV2,
} from '@protos/learning_management/lms.connected.apis_pb';
import { AttemptStats } from '@protos/learning_management/lms.db_pb';
import { createSlice } from '@reduxjs/toolkit';

export interface IStatusObj {
  [key: string]: {
    studentId: bigint;
    isSubmitted?: boolean;
    marks?: number;
  };
}
export interface IClickerAssessmentInfo {
  selected_attempt?: AttemptStats;
  statusInfo?: IStatusObj;
  previous_session_info?: TeacherPreviousAssessmentSession;
}
export interface IStudentClickerDataObj extends StudentClickerData {
  // connectedClassSessionStudentId?: bigint;
  rank?: number | string;
}
export interface IClickerAssessmentState {
  ca_base_station_details?: BaseStationDetails;
  student_list?: IStudentClickerDataObj[];
  clicker_assessment_session_data?: UpsertConnectedClassSessionResponseV2;
  teacher_assessment_session_details?: CreateTeacherAssessmentSessionResponse;
  assessment_content?: AssessmentContent;
  current_question_index: number;
  ca_question_session_details?: IQuestionSession;
  clicker_assessment_info?: IClickerAssessmentInfo;
  session_start_type: 'start' | 'resume';
}
export interface IQuestionSession {
  question_session_id?: bigint;
  question_id: string;
}

const initialState: IClickerAssessmentState = {
  ca_base_station_details: undefined,
  student_list: undefined,
  clicker_assessment_info: undefined,
  current_question_index: 0,
  session_start_type: 'start',
};

export const clickerAssessmentSlice = createSlice({
  name: 'clickerAssessment',
  initialState,
  reducers: {
    setCABaseStationDetails: (
      state,
      action: { payload: BaseStationDetails | undefined }
    ) => {
      // console.log('payload', action.payload);
      state.ca_base_station_details = action.payload;
    },
    setStudentList: (
      state,
      action: { payload: StudentClickerData[] | undefined }
    ) => {
      // console.log('payload', action.payload);
      state.student_list = action.payload;
    },
    setClickerAssessmentSessionData: (
      state,
      action: { payload: UpsertConnectedClassSessionResponseV2 | undefined }
    ) => {
      // console.log('payload', action.payload);
      state.clicker_assessment_session_data = action.payload;
    },
    setTeacherAssessmentSessionDetails: (
      state,
      action: { payload: CreateTeacherAssessmentSessionResponse | undefined }
    ) => {
      // console.log('payload', action.payload);
      state.teacher_assessment_session_details = action.payload;
    },
    setAssessmentContent: (
      state,
      action: { payload: AssessmentContent | undefined }
    ) => {
      // console.log('payload', action.payload);
      state.assessment_content = action.payload;
    },
    setQuestionIndex: (state, action: { payload: number }) => {
      // console.log('payload', action.payload);
      state.current_question_index = action.payload;
    },
    setQuestionSessionDetails: (
      state,
      action: { payload: IQuestionSession | undefined }
    ) => {
      // console.log('payload', action.payload);
      state.ca_question_session_details = action.payload;
    },
    setClickerAssessmentInfo: (
      state,
      action: { payload: IClickerAssessmentInfo | undefined }
    ) => {
      state.clicker_assessment_info = action.payload;
    },
    setSessionStartType: (state, action: { payload: 'start' | 'resume' }) => {
      state.session_start_type = action.payload;
    },
    resetClickerAssessmentState: (state) => {
      return initialState;
    },
  },
});

export const {
  setCABaseStationDetails,
  setStudentList,
  resetClickerAssessmentState,
  setClickerAssessmentSessionData,
  setTeacherAssessmentSessionDetails,
  setAssessmentContent,
  setQuestionIndex,
  setQuestionSessionDetails,
  setClickerAssessmentInfo,
  setSessionStartType,
} = clickerAssessmentSlice.actions;
export default clickerAssessmentSlice.reducer;
